      export async function analyzeResults(self, query, mode) {
          let w = self;
          let freesub = w.subs && w.subs.subType == 'free' ? true : false
          let params = {
              credits: 250
          };
          let newParams;
          let credits = w.subs.credits || 0
          if (credits < params.credits) {
              let buttons = [{
                  title: 'Cancel',
                  default: true,
                  handler: () => {
                      w.closable = false;
                      w.$modal.hide('dialog');
                  } // Button click handler
              }]
              if (freesub) {
                  buttons.unshift({
                      title: '<b>Subscribe</b>',
                      handler: () => {
                          w.createNew = false;
                          w.$modal.hide('dialog');
                          w.recordEvent('subButtonAnalyze', {
                              'event_category': 'function',
                              'event_label': 'User initiated'
                          })
                          w.$eventBus.$emit('appEvents', {
                              exec: 'checkSubStatus',
                              component: 'nav',
                          })
                      } // Button click handler
                  })
              } else {
                  buttons.unshift({
                      title: 'Add Credits',
                      handler: () => {
                          w.createNew = false;
                          w.$modal.hide('dialog');
                          w.recordEvent('subButtonAnalyze', {
                              'event_category': 'function',
                              'event_label': 'User initiated'
                          })
                          w.$eventBus.$emit('appEvents', {
                              exec: 'checkSubStatus',
                              params: 'addon',
                              component: 'nav',
                          })
                      } // Button click handler
                  })
              }
              w.$modal.show('dialog', {
                  title: 'Insuffcicent credits to run Analysis',
                  text: `This analysis generates a comprehensive explanation of the results and <b>simulated images</b> illustrating the phenotype of the tested sample<br><br>You need at least ${params.credits} credits to continue<br><b>` + (freesub ? `Help support us by subscribing to our services</b><br>` : 'Please add credits</b><br>'),
                  class: 'warning',
                  buttons: buttons
              })
              w.spinner = false;
              return
          }
          if (mode == 'pca') {
              w.explaining = true;
              setTimeout(async () => {
                  let image = document.getElementById('pcaDiv')
                  let width = 1280
                  let height = 800
                  let data = await PlotlyInstance.toImage('pcaDiv', {
                      format: 'png',
                      width: width,
                      height: height
                  })
                  const mimeType = "image/png"; // or "image/jpeg", etc.
                  const fileName = "plot.png";

                  // Convert base64 to Blob
                  function base64ToBlob(base64, mime) {
                      const binary = atob(base64);
                      const array = Uint8Array.from(binary, c => c.charCodeAt(0));
                      return new Blob([array], {
                          type: mime
                      });
                  }

                  // Trigger download
                  const blob = base64ToBlob(data.split(',')[1], mimeType);
                  window.saveAs(blob, `test.png`);
                  w.explaining = false;
                  throw new Error('Hellooo!')
              }, 2000)
              return;
          };
          if (mode == 'nmonte') {
              if (w.secondaryTabs == 'table' && w.gridApi && w.gridApi.getSelectedRows && w.gridApi.getSelectedRows() && w.gridApi.getSelectedRows().length) {
                  let selectedRows = w.gridApi.getSelectedRows();
                  let chartindex = 0;
                  chartindex = w.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '').replace(/_/g, ' ')} (${x.alias.split(':')[0].replace(/_/g, ' ')})`.trim() == selectedRows[0].sample.replace(/_/g, ' ').trim())
                  w.currentChartIndex = chartindex;
              } else {
                  let profile = w.categories[w.currentIndex]
                  let chartindex = 0;
                  chartindex = w.chartJSON.findIndex(x => `${x.alias.split(':')[0].replace(/-raw/, '').replace(/_/g, ' ')} ► ${x.alias.split(':')[1]}`.replace(/_/g, ' ').trim() == profile.replace(/-raw/, '').replace(/_/g, ' ').trim())
                  w.currentChartIndex = chartindex;
              }
          } else {
              if (w.secondaryTabs == 'table' && w.gridApi && w.gridApi.getSelectedRows && w.gridApi.getSelectedRows() && w.gridApi.getSelectedRows().length) {
                  let selectedRows = w.gridApi.getSelectedRows();
                  let chartindex = 0;
                  chartindex = w.chartJSON.findIndex(x => `${x.profile.split(':')[1].replace(/-raw/, '').replace(/_/g, ' ')} (${x.profile.split(':')[0]})`.trim() == selectedRows[0].originalsample.replace(/_/g, ' ').trim())
                  w.currentChartIndex = chartindex;
              } else {
                  let profile = w.categories[w.currentIndex]
                  let chartindex = 0;
                  chartindex = w.chartJSON.findIndex(x => `${x.alias.split(':')[1].replace(/-raw/, '')} (${x.alias.split(':')[0]})`.replace(/_/g, ' ').trim() == w.categories[w.currentIndex].replace(/-raw/, '').replace(/_/g, ' ').trim() || (x.alias.split(':')[0].replace(/_/g, ' ').includes(profile.split(' (')[1].replace(/_/g, ' ').replace(')', '')) && x.alias.split(':')[1].replace(/_/g, ' ').trim().includes(profile.split(' (')[0].replace(/_/g, ' ').trim())))
                  w.currentChartIndex = chartindex;
              }
          }
          let buttons = [{
                  title: 'Yes',
                  handler: (index, event, {
                      inputValue
                  }) => {
                      w.createNew = false;
                      w.$modal.hide('dialog');
                      analyzeResults(inputValue);
                  } // Button click handler
              },
              {
                  title: 'No',
                  default: true,
                  handler: () => {
                      w.closable = false;
                      w.$modal.hide('dialog');
                  } // Button click handler
              }
          ]
          w.$modal.show('dialog', {
              title: 'Run deep analysis?',
              showInput: true,
              inputMaxLength: 300,
              inputInitiallyOpen: false,
              input_title: 'Click here to add Optional Ancestry Details',
              //input_title: 'Optional Context',
              placeholder: 'You can use this space to provide optional additional context like known ancestry, or any specific question(s) you might have related to the results',
              text: 'Running this analysis will generate a comprehensive explanation of the results. You will also receive <b>simulated images</b> illustrating the phenotype of the tested sample, along with detailed descriptions of each component utilized in the calculator',
              text2: 'This report can use up to 250 credits.<br>Do you want to continue?',
              class: 'alert',
              buttons: buttons
          })
          async function analyzeResults(input) {
              w.spinner = true;
              w.recordEvent('analyzeResults', {
                  'event_category': 'function',
                  'event_label': 'User initiated'
              })
              //try {
              if (w.G25calc || mode == 'nmonte') {
                  if (mode == 'nmonte') {
                      w.calcArray = w.groupArray;
                      w.rswitches = w.switches;
                      w.rawArrayLocal = w.sampleArray;
                  }
                  let subId = w.$store.getters.get('user').username + ':' + w.queryTimeStamp;
                  let nearGroups = [...w.chartJSON[w.currentChartIndex].nearest]
                  let gmode = 'G25'
                  let customsamples = false;
                  let group = []
                  nearGroups.map(x => {
                      if (x._row) group.push(x._row.split(':')[0])
                  })
                  let unique = new Set(group)
                  let groups = [...unique].slice(0, 8);
                  let nearest = false
                  let calculator = w.calcArray[0].calculator;
                  console.log('calculator', calculator);
                  let quantity = w.calcArray[0].samples;
                  let filtered = quantity > 800 ? true : w.aggregatedCalc && !w.rswitches.removeOutliers ? false : true
                  let averaged = quantity > 800 ? undefined : w.aggregatedCalc && w.rswitches.groupAveraged ? true : undefined
                  let median = quantity > 800 ? true : w.aggregatedCalc && w.rswitches.groupMedian ? true : undefined
                  let eta = filtered ? (quantity / 60) * 1000 : (quantity / 300) * 1000
                  let creator = w.calcArray[0].user;
                  let type = 'getOracle'
                  let gparams = {
                      filtered: filtered,
                      averaged: averaged,
                      median: median,
                  }
                  let index = w.currentIndex ? w.currentIndex : 0
                  newParams = JSON.parse(JSON.stringify(gparams));
                  let grpsmpl = mode == 'nmonte' ? w.categories[index].split('►') : w.categories[index].split(' (')
                  let grp = grpsmpl[1].replace(/\)/, '').trim()
                  let smpl = grpsmpl[0].trim()
                  grpsmpl = mode == 'nmonte' ? `${smpl}:${grp}` : `${grp}:${smpl}`
                  let fullsample = w.rawArrayLocal.find(x => x.alias ? (x.alias + ':' + x.index.split(':')[1] == grpsmpl) : x.index == grpsmpl)
                  newParams.groups = groups;
                  //newParams.sample = w.categories[index].replace(/ ► /g, ':');
                  newParams.sample = fullsample.index
                  if (w.g25customsamples && w.g25customsamples.length > 0 && w.g25customsamples.findIndex(x => x == newParams.sample) >= 0) customsamples = w.g25Rerun
                  newParams.sample = fullsample.v ? newParams.sample.split(':')[0] + '|' + fullsample.v + ':' + newParams.sample.split(':')[1] : newParams.sample
                  newParams.subtype = w.subs && w.subs.subType ? w.subs.subType : 'free'
                  newParams.calculator = calculator;
                  newParams.creator = creator;
                  newParams.raw = false
                  //newParams.id = subId;
                  newParams.id = w.categories[index].replace(/ ► /g, ':') + ':oracle'
                  newParams.sub = subId;
                  newParams.nearest = nearest;
                  newParams.customsamples = customsamples;
                  newParams.result = w.chartJSON[w.currentChartIndex] && w.chartJSON[w.currentChartIndex].groupResult ? w.chartJSON[w.currentChartIndex].groupResult : w.chartJSON[w.currentChartIndex] && w.chartJSON[w.currentChartIndex].result ? w.chartJSON[w.currentChartIndex].result : false;
                  params = {
                      ...params,
                      ...newParams
                  };
              } else {
                  let creator = 'internalGenoplot'
                  let calc = w.calcArray[0].calculator
                  let coords = []
                  let index = w.currentIndex ? w.currentIndex : 0
                  let components = w.G25calc ? window.g25cache.getCalculators.find(x => x.calculator === calc).components : window.g25cache.getAdmixCalculators.find(x => x.calculator === calc).components
                  if (!w.G25calc) {
                      components.map(x => {
                          coords.push(w.chartJSON[w.currentChartIndex].result[x.replace(/_/g, ' ')] ? w.chartJSON[w.currentChartIndex].result[x.replace(/_/g, ' ')] : w.chartJSON[w.currentChartIndex].result[x] ? w.chartJSON[w.currentChartIndex].result[x] : 0)
                      })
                  }
                  let oparams = {};
                  if (!w.G25calc) {
                      oparams = {
                          filtered: true,
                          admix: true,
                          sampleCoords: {
                              sample: w.categories[w.currentIndex].replace(/-raw/, ''),
                              group: w.user.username,
                              coords: coords.join(',')
                          }
                      }
                  }
                  newParams = JSON.parse(JSON.stringify(oparams));
                  newParams.groups = [1, 2]
                  newParams.sample = w.user.username + ':' + w.categories[index].replace(/-raw/, '')
                  newParams.subtype = w.subs && w.subs.subType ? w.subs.subType : 'free'
                  newParams.calculator = calc;
                  newParams.creator = creator;
                  newParams.id = w.categories[index].replace(/ ► /g, ':')
                  newParams.nearest = [];
              }
              let calc = w.calcArray[0].calculator
              let payload = {
                  date: Date.now(),
                  version: w.calcArray[0] && w.calcArray[0].v ? w.calcArray[0].v : 0,
                  user: w.user.username,
                  json: [w.chartJSON[w.currentChartIndex]],
                  index: w.currentIndex,
                  key: w.chartKey,
                  mode: w.G25calc || mode == 'nmonte' ? 'G25' : undefined,
                  categories: [w.categories[w.currentIndex]],
                  components: w.components,
                  calculator: w.calcArray[0] && w.calcArray[0].calculator && w.calcArray[0].owner ? w.calcArray[0].owner + ':' + calc : undefined,
                  calcArray: w.calcArray.map(x => x.index ? x.index : x.label),
              }
              if (w.alias && !(w.activeName && !w.createNew) || w.alias && !w.createNew && w.activePath && w.activePath.split('/')[0] == w.alias) {
                  payload.alias = w.alias;
              }
              let name = w.alias ? w.alias : w.user.username;
              let path = `${name}/${Date.now().toString(16)}`
              let type = w.G25calc || mode == 'nmonte' ? 'g25' : 'admix';
              payload.name = name
              let theme = w.theme ? 2 : 1
              payload.path = path
              if (w.topics && w.topics[path]) payload.published = w.topics[path]
              payload.theme = theme
              let contentType = 'application/json'
              let sigparams = {
                  filePath: path,
                  fileType: type,
                  shareType: 'Analysis',
                  email: w.user.email,
                  username: w.user.username,
                  contentType: contentType,
                  payload: payload
              }
              params.useHistory = w.ahistory ? true : false;
              params.nmonte = mode == 'nmonte' ? true : false
              params.sigparams = sigparams;
              params.userInput = input;
              params.oracles = newParams;
              console.log('invoking', params);
              const invoke = await w.$apollo.query({
                  query: query,
                  variables: {
                      params: JSON.stringify(params)
                  }
              })
              console.log('DataAnalysis', invoke)
              w.spinner = false;
              if (invoke && invoke.data && invoke.data.invokeAnalyzeResults && invoke.data.invokeAnalyzeResults.result) {
                  let result = JSON.parse(invoke.data.invokeAnalyzeResults.result)
                  if (result.status == 200) {
                      w.$eventBus.$emit('appEvents', {
                          exec: 'show',
                          component: 'nav',
                          params: {
                              title: 'Analysis Started',
                              text: `<b>We've started the analysis<br>We'll notify you as soon as it completes!</b><br><br>Click on the <b>History</b> menu to get current status.<br><br>This is an experimental feature, so all feedback is welcome!`,
                              class: 'alert',
                          }
                      })
                      try {
                          w.openDrawer = false;
                      } catch (err) {
                          console.log(err);
                      }
                  } else {
                      throw new Error('Unable to initiate Analysis');
                  }
              } else {
                  w.$eventBus.$emit('appEvents', {
                      exec: 'show',
                      component: 'nav',
                      params: {
                          title: 'Error',
                          text: `Unable to start analysis`,
                          class: 'warning'
                      }
                  })
              }
              w.spinner = false;
              /*
              } catch (err) {
                  let error = err.message || err
                  console.log('ErrorAnalysis', error, err.stack)
                  let message = error && error.toString().includes('Not enough credits') ? `Unfortunately, you appear to have insufficient credits to execute w analysis<br><br><b>You need at least ${params.credits} credits</b>` : error
                  w.$eventBus.$emit('appEvents', {
                      exec: 'show',
                      component: 'nav',
                      params: {
                          title: 'Error',
                          text: message,
                          class: 'warning'
                      }
                  })
                  w.spinner = false;
              }
              */
              w.spinner = false;
          }

      }
